export default function AudioPlayer({ src, className = "" }) {
    if (!src) return <span className="block w-full truncate text-sm text-gray-500">Sem gravação</span>;

    return (
        <div className={`w-full min-w-0 overflow-hidden ${className}`.trim()}>
            <audio controls preload="metadata" className="block h-8 w-full max-w-full min-w-0">
                <source
                    src={src}
                    type="audio/mpeg"
                    className="h-6 w-full scale-y-75"
                />
                Seu navegador não suporta áudio.
            </audio>
        </div>
    )
}